import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import Clock from "../components/Clock";
import IpInfo from "../components/IpInfo";
import Greeting from "../components/Greeting";
import Quote from "../components/Quote";

const StartContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  height: 100%;
  width: 80%;
  ${"" /* border: 1px solid white; */}
`;

const TimeIpContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid white;
  box-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
`;

const Divider = styled.div`
  background-color: white;
  box-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  width: 85%;
  height: 2px;
`;

const Filler = styled.div`
  height: 10vh;
`;

const StartPage = () => {
  return (
    <StartContainer>
      <TimeIpContainer>
        <Clock></Clock>
        <Divider></Divider>
        <IpInfo></IpInfo>
      </TimeIpContainer>
      <Greeting></Greeting>
      <Quote></Quote>
      <Filler></Filler>
    </StartContainer>
  );
};

export default StartPage;
